import React, { useState, useRef, useEffect } from 'react';
import useEditorStore from '../../store/editorStore';
import './TextBlock.css';

function TextBlock({ block }) {
  const [isEditing, setIsEditing] = useState(false);
  const [content, setContent] = useState(block.content || '');
  const textRef = useRef(null);
  const { updateBlock } = useEditorStore();

  const getBackgroundStyle = () => {
    if (block.styles.backgroundType === 'gradient') {
      return { background: block.styles.backgroundGradient };
    }
    return { backgroundColor: block.styles.backgroundColor };
  };

  const styles = {
    fontFamily: block.styles.fontFamily,
    fontSize: `${block.styles.fontSize}px`,
    fontWeight: block.styles.fontWeight,
    fontStyle: block.styles.fontStyle,
    textDecoration: block.styles.textDecoration,
    textAlign: block.styles.textAlign,
    color: block.styles.color,
    ...getBackgroundStyle(),
    padding: `${block.styles.padding}px`,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
  };

  const handleDoubleClick = (e) => {
    e.stopPropagation();
    setIsEditing(true);
  };

  const handleBlur = () => {
    setIsEditing(false);
    updateBlock(block.id, { content });
  };

  const handleChange = (e) => {
    setContent(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Escape') {
      setIsEditing(false);
      updateBlock(block.id, { content });
    }
  };

  useEffect(() => {
    if (isEditing && textRef.current) {
      textRef.current.focus();
      textRef.current.select();
    }
  }, [isEditing]);

  if (isEditing) {
    return (
      <textarea
        ref={textRef}
        className="text-block-editor"
        style={styles}
        value={content}
        onChange={handleChange}
        onBlur={handleBlur}
        onKeyDown={handleKeyDown}
        onClick={(e) => e.stopPropagation()}
      />
    );
  }

  return (
    <div
      className="text-block"
      style={styles}
      onDoubleClick={handleDoubleClick}
    >
      {content || 'ดับเบิลคลิกเพื่อแก้ไข'}
    </div>
  );
}

export default TextBlock;
